export default __webpack_public_path__ + "static/media/checked-out.9d11837a.svg";